"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAccHostname = void 0;
/**
 * This function is duplicated from https://git.autodesk.com/BIM360/acs-sc-web-platform/blob/master/packages/TopNavigation/helpers/getAccHostname.js
 *
 * TODO: alloy should export this so we can consume it
 */

/**
 * This method return a normalized ACC hostname - according to env, or QA for local.
 * @return {string}
 */
const getAccHostname = () => window.location.hostname.includes("local.acc-qa.autodesk.com") ? "acc-qa.autodesk.com" : window.location.hostname;
exports.getAccHostname = getAccHostname;
//# sourceMappingURL=getAccHostname.js.map